export default __webpack_public_path__ + "static/media/english-to-danish-screenshot-02.b0fb2f5c.png";